// 引入axios
import axios from "axios";
import qs from "qs";
import { Toast } from "vant";
import { baseURL } from "./config";

//创建axios实例
// const baseURL = "/api"
const service = axios.create({
  baseURL: baseURL, // api的base_url
  // baseURL: "/api", // api的base_url
  timeout: 1000000 // 请求超时设置
});

//设置请求拦截
service.interceptors.request.use(
  res => {
    // 用于兼容ie浏览器：判断是否是get请求，方式：拼接一个随机数，
    if (res.method === "get") {
      if (res.params) {
        res.params.t = new Date().getTime();
      } else {
        res.url = res.url + "?t" + new Date().getTime();
      }
    }
    // 接口请求带上token
    // let token = sessionStorage.getItem("token");
    // if (token && token != "") {
    //   res.headers["Authorization"] = "Bearer " + token;
    // }
    return res;
  },
  error => Promise.reject(error)
);

// 设置响应拦截器
service.interceptors.response.use(
  response => {
    return response.data;
  },
  error => {
    let { response } = error;
    if (response) {
      // 服务器返回结果
      switch (response.status) {
        case 401:
          // Message({
          //   Toast : "未授权，请重新登录",
          //   type: "error",
          //   duration: 3 * 1000
          // });
          Toast.loading({
            message: "未授权，请重新登录",
            forbidClick: true,
            duration: 3 * 1000
          });
          break;
        case 403:
          // Message({
          //   message: "拒绝访问",
          //   type: "error",
          //   duration: 3 * 1000
          // });
          Toast.loading({
            message: "拒绝访问",
            forbidClick: true,
            duration: 3 * 1000
          });
          break;
        case 404:
          // Message({
          //   message: "请求错误,未找到该资源",
          //   type: "error",
          //   duration: 3 * 1000
          // });
          Toast.loading({
            message: "请求错误,未找到该资源",
            forbidClick: true,
            duration: 3 * 1000
          });
          break;
      }
    } else {
      // 服务器没有返回结果
      if (!window.navigator.onLine) {
        // 断网处理：跳转到断网页面
        Dialog.confirm({
          message: "网络异常 请检查网络"
        })
          .then(() => {})
          .catch(() => {});
        // return;
      }
      return Promise.reject(error);
    }
  }
);

// get请求
export function get(url, params) {
  return new Promise((resolve, reject) => {
    axios
      .get(baseURL + url, {
        params: params
      })
      .then(
        response => {
          resolve(response);
        },
        err => {
          reject(err);
        }
      )
      .catch(error => {
        reject(error);
      });
  });
}

//   post请求
export function post(url, data) {
  return new Promise((resolve, reject) => {
    axios
      .post(baseURL + url, qs.stringify(data))
      .then(
        response => {
          resolve(response);
        },
        err => {
          reject(err);
        }
      )
      .catch(error => {
        reject(error);
      });
  });
}

export default service;



// WEBPACK FOOTER //
// ./src/utils/axios.js